import PrivateSectionGate from "../Utility/PrivateSectionGate";

const GuitarTabsGate = (props) => (
  <PrivateSectionGate
    title="Guitar tabs"
    description="Sign in to view and manage your private tab library."
    className="GuitarTabsLoginGate"
  >
    {props.children}
  </PrivateSectionGate>
);

export default GuitarTabsGate;
